import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import React from 'react';

const SKELETON_LINE_WIDTHS = ['100%', '92%', '97%', '85%', '60%'];

const DraftGenerationSkeleton: FC = () => {
  return (
    <div
      className="ai-draft-skeleton"
      role="status"
      aria-busy="true"
      data-test-id="ai-draft-skeleton"
    >
      <div className="ai-draft-skeleton-status">
        <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
        Generating draft from source documents…
      </div>
      <div className="ai-draft-skeleton-lines" aria-hidden="true">
        {SKELETON_LINE_WIDTHS.map((width, index) => (
          <div
            key={index}
            className="ai-draft-skeleton-line"
            style={{ width }}
          />
        ))}
      </div>
    </div>
  );
};

export default DraftGenerationSkeleton;
